import { Button,HStack, } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import {useAppSelector } from 'src/redux/hooks';


type Props = {
    id:string
}

const ProfileButton = ({id}:Props) => {
    const {status} = useAppSelector((state)=>state.patient)
    const navigate = useNavigate()
    
    const goToConsulter= () => {
      navigate(`/assistant/patients/${id}`)
    }

    if(status === 0){
      return null
    }

  return (
  <HStack justifyContent='center' alignItems='center' h='100%' >
    <Button colorScheme='blue' onClick={goToConsulter} >Voir profile</Button>
  </HStack>
  )
}

export default ProfileButton